import { ReducedLegalEntityType } from "../../types/commonTypes/reducedLegalEntityType";


export const initialReducedLegalEntityState : ReducedLegalEntityType = {
    rcs: "",
    companyName: ""
}